import React from 'react'
import View from '../components/event-files/View'
import hipladeTemplate from '../../common/template'

function EventFiles() {
  return <View />
}

export default hipladeTemplate(EventFiles)
